import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetBijbEventSuccessAction } from '../../actions/bijb-event/get-event-success-action';
import { of } from 'rxjs';
import { GetCurrentUserAction } from '../../actions/current-user/get-current-user-action';
import { GetGroupsAction } from '../../actions/groups/get-groups-action';
import { Action } from '@ngrx/store';

@Injectable()
export class GetBijbEventSuccessEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetEvent = createEffect(() => this.actions
    .pipe(
      ofType(GetBijbEventSuccessAction.type),
      mergeMap(action => {
        const successAction = <GetBijbEventSuccessAction>action;
        if (successAction.bijbEvent == null) {
          return of<Action>();
        }
        return of(new GetCurrentUserAction(successAction.bijbEvent), new GetGroupsAction(successAction.bijbEvent));
      })
    ));
}
